export const NAME = 'directory';

export const DEFAULT_SORT = { id: -1, name: '--' };
export const CASHBACK_SORT = { id: 0, name: 'Cashback' };
export const NOM_SORT = { id: 1, name: 'Naam' };
export const LESPLUSPOPULAIRES_SORT = { id: 2, name: 'Meest populair' };
export const NOUVEAUTES_SORT = { id: 3, name: 'Nieuwtjes' };
export const NBCOUPON_SORT = { id: 4, name: 'Aantal kortingscodes' };

export const ABCBOOK_DEFAULT_LETTER = '123';

export const ASC = 'asc';
export const DESC = 'desc';

export const NB_AFFICHAGE_GRILLE = 16;

/**
 * Here goes the actionTypes
 */

export const CHANGE_CURRENT_FILTER = 'CHANGE_CURRENT_FILTER';
export const RESET_FILTER = 'RESET_FILTER';



// WEBPACK FOOTER //
// ./src/services/directory/constants.js